<template>
  <div>
    <yjh-header :activeIndex="idnex"></yjh-header>
    <div class="contentBox w">
      <div class="contentStitle">Recruitment center</div>
      <div class="contentTitle">招聘中心</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
    </div>
    <yjh-footer></yjh-footer>
  </div>
</template>

<script>
import footer from "@/layouts/footer";
import header from "@/layouts/header";
export default {
  components: {
    "yjh-footer": footer,
    "yjh-header": header,
  },
  data() {
    return {
      idnex: "5-1",
    };
  },
};
</script>

<style>
</style>